import React, { useEffect, useState } from 'react'

import { Footer } from '../components/Footer'
import { TopLogo } from '../components/TopLogo'

const Privacy: React.FC = () => {
  const [html, setHtml] = useState<string>('')
  const [error, setError] = useState<string>('')

  // Fetch the HTML content - no changes here
  useEffect(() => {
    fetch('/legal/privacy.html')
      .then((res) => (res.ok ? res.text() : Promise.reject('Not found')))
      .then((text) => {
        // Convert simple Markdown-style bold (**text**) to HTML <strong>
        const withBold = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        setHtml(withBold)
      })
      .catch(() => setError('Privacy Policy content not found.'))
  }, [])

  // NEW & IMPROVED EFFECT: This handles clicks reliably using event delegation.
  useEffect(() => {
    if (!html) return // Only run when HTML is loaded

    const container = document.getElementById('privacy-content')
    if (!container) return

    const handleContainerClick = (event: MouseEvent) => {
      // Check if the clicked element is an anchor link (<a>) with a hash (#) href
      const target = event.target as HTMLElement
      const link = target.closest('a[href^="#"]')

      if (link) {
        // This is the key: stop React Router and the browser from navigating
        event.preventDefault()

        const href = link.getAttribute('href')
        if (href) {
          // Find the section by its ID and scroll to it smoothly
          const targetElement = document.querySelector(href)
          targetElement?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      }
    }

    // Add a single click listener to the parent container
    container.addEventListener('click', handleContainerClick)

    // Important: Clean up the listener when the component is removed
    return () => {
      container.removeEventListener('click', handleContainerClick)
    }
  }, [html]) // This effect re-runs only when the 'html' content changes

  return (
    <div id="page-root" className="h-screen overflow-auto relative bg-neutral-50">
      <TopLogo />

      <div className="px-4 py-6 md:py-8 max-w-4xl mx-auto relative">
        <h1 className="text-3xl md:text-4xl font-bold text-neutral-800 mb-4">Privacy Policy</h1>
        {error && <div className="text-red-600 mb-4">{error}</div>}
        <div
          id="privacy-content"
          className="prose prose-neutral max-w-none bg-white rounded-xl shadow-soft border border-neutral-200 p-4 md:p-8"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>

      <div className="mt-12">
        <Footer />
      </div>
    </div>
  )
}

export default Privacy
